import config from 'config';

export const UNAUTHORIZED = 'UNAUTHORIZED';
export const IS_AUTHORIZED = 'IS_AUTHORIZED';
export const FACEBOOK_ID = '118062578906576';
export const FACEBOOK_AUTH = `https://www.facebook.com/v2.10/dialog/oauth?client_id=${FACEBOOK_ID}&display=popup&response_type=token&redirect_uri=${config.facebookRedirectUrl}`;
export const VIMEO_PLAYER_PREFIX = 'https://player.vimeo.com/video/'
export const USER_TYPE = [
  {value: 0, title: 'GP'},
  {value: 1, title: 'GP Registrar'},
  {value: 7, title: 'GP Trainee'},
  {value: 2, title: 'Consultant'},
  {value: 3, title: 'Hospital Doctor'},
  {value: 4, title: 'Pharmacist'},
  {value: 5, title: 'Student'},
  {value: 6, title: 'Other'},
];

export const COUNTIES = [
  { title: 'Antrim', value: 0 },
  { title: 'Armagh', value: 1},
  { title: 'Carlow', value: 2},
  { title: 'Cavan', value: 3},
  { title: 'Clare', value: 4},
  { title: 'Cork', value: 5},
  { title: 'Derry', value: 6},
  { title: 'Donegal', value: 7},
  { title: 'Down', value: 8},
  { title: 'Dublin North', value: 9},
  { title: 'Dublin South', value: 33},
  { title: 'Fermanagh', value: 10},
  { title: 'Galway', value: 11},
  { title: 'Kerry', value: 12},
  { title: 'Kildare', value: 13},
  { title: 'Kilkenny', value: 14},
  { title: 'Laois', value: 15},
  { title: 'Leitrim', value: 16},
  { title: 'Limerick', value: 17},
  { title: 'Longford', value: 18},
  { title: 'Louth', value: 19},
  { title: 'Mayo', value: 20},
  { title: 'Meath', value: 21},
  { title: 'Monaghan', value: 22},
  { title: 'Offaly', value: 23},
  { title: 'Roscommon', value: 24},
  { title: 'Sligo', value: 25},
  { title: 'Tipperary', value: 26},
  { title: 'Tyrone', value: 27},
  { title: 'Waterford', value: 28},
  { title: 'Westmeath', value: 29},
  { title: 'Wexford', value: 30},
  { title: 'Wicklow', value: 31}
];

export const COUNTRIES = [
  { title: 'Ireland', value: 3},
  { title: 'Australia', value: 0 },
  { title: 'Canada', value: 1},
  { title: 'England', value: 2},
  { title: 'Malaysia', value: 10},
  { title: 'Northern Ireland', value: 4},
  // { title: 'Qatar', value: 5},
  { title: 'Scotland', value: 6},
  { title: 'Wales', value: 7},
  { title: 'Other', value: 9},
];

export const RESOURCE_TYPES = [
  {value: 0, title: 'CCT Practice case'},
  {value: 1, title: 'CKT Revision Summaries'},
];

export const ResourceType = {
  cct: 0,
  ckt: 1,
};

export const INITIAL_USER = {
  first_name: '',
  last_name: '',
  email: '',
  email_confirmation: '',
  password: '',
  user_type: '',
  phone_number: '',
  imc: '',
  nmbi: '',
  county: '',
  practice_address: ''
};

export const modules = {
  toolbar: [
    [{ 'color': ['#2E3C4C','#565A5E'] }],
    ['bold', 'italic', 'underline'],
    ['link', 'image'],
    [{ 'size': ['small', false, 'large'] }],
    [{ 'align': [] }],
    ['clean']
  ]
};

export const formats = [
  'color',
  'size',
  'bold',
  'underline',
  'italic',
  'link',
  'image',
  'align',
];

export const titleModules = {
  toolbar: [
    [{ 'color': ['#2E3C4C','#565A5E'] }],
    ['bold', 'italic', 'underline'],
    [{ 'size': ['small', false, 'large'] }],
    ['clean']
  ]
};

export const titleFormats = [
  'color',
  'size',
  'bold',
  'italic'
];



// WEBPACK FOOTER //
// ./src/constants/baseConst.js